import {History} from '../../../graphql-typings/graphql';
import {PeriodFunction} from './period-function';
import {AccumulatingChartFunction, FunctionName} from './chart-function-types';
import {IterableUtil} from '@app/shared/util/collections/collection-utils';

export interface MinimumContext {
  minimum: number | null;
}

export class MinimumFunction extends PeriodFunction implements AccumulatingChartFunction<MinimumContext> {

  constructor() {
    super(FunctionName.MIN, 'Minimum');
  }

  run(historyArray: History[], padValues?: boolean): History[] {
    return this.applyPeriodFunction(historyArray, (ha: History[]) => this.getAggregate(this.accumulate(ha, null)), padValues);
  }

  accumulate(history: Iterable<History>, context: MinimumContext | null): MinimumContext {
    let minimum: number | null = context?.minimum ?? null;
    IterableUtil.forEach(history, historyItem => {
      minimum = Math.min(minimum ?? Number.POSITIVE_INFINITY, historyItem.data);
    });
    const newContext: MinimumContext = {...context, minimum};
    return newContext;
  }

  getAggregate(context: MinimumContext): number {
    return context.minimum;
  }
}
